export default __webpack_public_path__ + "static/media/tech_background_left.620a37f3.png";